import {z} from 'zod';
import validator from 'validator';

import constants from 'client/constants';

const {PASSWORD: PASSWORD_REGEX} = constants.REGEX_COLLECTION;

export const signUpFormSchema = z.object({
  email: z
    .string()
    .max(128)
    .refine((val) => !val || validator.isEmail(val), {
      message: 'Your email address is not valid'
    }),
  password: z.string().refine((val) => !val || PASSWORD_REGEX.test(val), {
    message:
      'Passwords must have at least 8 characters and at least one number or special character.'
  })
});

export type SignUpFormValues = z.infer<typeof signUpFormSchema>;
